import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { VehicleCategoryAvailabilityModeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-availability-mode.enum';
import { VehicleCategoryTypeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-type.enum';

/**
 * Vehicle category DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_CATEGORY)
export class VehicleCategoryListDto extends BaseDto {
  name!: string;
  type!: VehicleCategoryTypeEnum;
  availabilityMode?: VehicleCategoryAvailabilityModeEnum | null;
  description?: string | null;
  depositPercentage?: number | null;
  depositFlatRate?: number | null;
  standardDiscountPercentage?: number | null;
  excessAmount?: number | null;
  reducedExcessAmount?: number | null;
  minAgeLimit?: number | null;
  youngDriverAgeLimit?: number | null;
  maxAgeLimit?: number | null;
  seniorAgeLimit?: number | null;
  minDrivingYears?: number | null;
}
